//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// import created components  :
import Background from '../../components/background/Background.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
import TutoModal from '../../components/tutomodal/TutoModal.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { clientSlice } from "../../store/clientSlice.js";
import { formulesSlice } from "../../store/formulesSlice.js";
import { resaSlice } from "../../store/resaSlice.js";
import { getSelectedCreneaux } from "../../store/selectors.js";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CheckIcon from '@mui/icons-material/Check';
import Modal from '@mui/material/Modal';
import InfoIcon from '@mui/icons-material/Info';
import StarIcon from '@mui/icons-material/Star';
import HelpIcon from '@mui/icons-material/Help';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import SurfingIcon from '@mui/icons-material/Surfing';
import FastForwardIcon from '@mui/icons-material/FastForward';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import SyncIcon from '@mui/icons-material/Sync';
import Alert from '@mui/material/Alert';

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function Home() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const lang = useSelector(getLang) //global state : shopping step

    // reset previous resa infos to null
    dispatch(resaSlice.actions.setResa({}));

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [connect, setConnect] = useState(false);


    //// -- check if connection with DB backend is ok
    axios.get(baseURL + "/client")
        .then((response) => {
            console.log(response);

            if (response.status === 200) {
                if (response.data.length > 2) {
                    setConnect(true);
                }
                else {
                    setConnect(false);
                }
            }
            else {
                setConnect(false);
            }

        })
        .catch((error) => {
            setConnect(false);
        })
    ////---




    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner size={"big"} />


                    <div className="home-resa">

                        <div className="home-resa-intro">
                            <h3><span>{translator("Bienvenue", lang, "homeInvite1")}</span> <span>{translator("sur la Wally plateforme de réservation", lang, "homeInvite2")}</span><span> {translator("de cours de surf en ligne.", lang, "homeInvite3")}</span></h3>
                            <div className="home-resa-intro-encart">
                                <figure><HelpIcon /></figure>

                                <p>{translator("C'est un nouvel outil simple et fonctionnel développé par nos soins qui permet à l'usager comme au staff de ", lang, "homeInfo1A")}<b>{translator("gagner du temps pour les modalités de réservations.", lang, "homeInfo1B")}</b></p>
                                <div className="home-resa-intro-encart-icons">
                                    <ImportantDevicesIcon />
                                    <SyncIcon />
                                    <FastForwardIcon />
                                    <SurfingIcon />

                                </div>
                            </div>

                            <div className="home-resa-intro-encart2">
                                <figure><ThumbUpIcon /></figure>

                                <p>{translator("Notre ambition est de faire pratiquer notre sport à tous, dans les meilleures conditions possible en évitant les mauvaises surprises...", lang, "homeInfo2")}</p>
                                <div className="home-resa-intro-encart2-icons">
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />

                                </div>
                            </div>

                            <img src={require("../../images/pins/pin_1.png")} alt="pin maritimie plage du lion" className="home-resa-intro-pin-1" />
                            <img src={require("../../images/pins/pin_2.png")} alt="pin maritimie plage du lion" className="home-resa-intro-pin-2" />
                        </div>

                        <div className="home-resa-main">
                            {/* <p>Suivez les <b>5 étapes rapides</b> pour nous envoyer vos demandes de pré-réservations.</p> */}
                            {/*  <ul>
                                <li><CheckIcon /> Renseignez les élèves surfeurs</li>
                                <li><CheckIcon /> Choisissez vos sessions grâce au calendrier interactif</li>
                                <li><CheckIcon /> Confirmez vos coordonnées</li>
                                <li><CheckIcon /> Possibilité de règlement en ligne (après validation du planning de sessions)</li>
                                <li><CheckIcon /> Et voilà!</li>
                            </ul> */}

                            <p>Besoin d'aide? consulte le <span onClick={_ => setOpen(true)}>guide d'utilisation</span>, mais ça devrait aller...</p>
                        </div>

                        <Button
                            className="home-resa-next-bouton"
                            variant="contained"
                            onClick={_ => navigate("/startresa")}
                            disabled={!connect}>
                            {connect ? translator("Reservez vos sessions", lang, "homeBt1") : translator("Service indisponible", lang, "homeBt2")}
                        </Button>
                        {connect ? null : <Alert severity="error">Service indisponible. Vous pouvez rafraîchir la page pour essayer à nouveau</Alert>}

                    </div>

                </div>
            </main>
            <Modal
                className="home-resa-modal"
                open={open}
                onClose={handleClose}
            >
                <TutoModal toStep={1} handleClose={handleClose} />
            </Modal>
        </div>
    );
}

export default Home;